export default {
  pesquisaplaca: [],
  pesquisaplacapg: [],
  pesquisaplacapgbk: [],
  pesquisaqtdplacas: 0,
  buscarpesquisaplacas: {
      selecionadoPontos: false,
      placaValido: true,
      L1: "%",
      L2: "%",
      L3: "%",
      N1: "%",
      N2: "%",
      N3: "%",
      N4: "%",
      strDateInicial: "",
      strDateFinal: "",
      strHoraInicial: "",
      strHoraFinal: "",
      strSelectdPontos: "",
      selectedTipo: "P"
  },
  buscaradar: [],
  buscacorporacao: [],
  buscaimagemP: "img/icons/carro.jpg",
  buscaimagemZ: "img/icons/carro.jpg",
  salvarimagem: "",
  pesquisalprbotbackend: "",
  pagesize: 10,
}